'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record } from 'immutable';
var defaults = {
  utm_campaign: null,
  utm_medium: null,
  utm_source: null,
  meeting_funnel: null,
  meeting_product: null,
  meeting_medium: null,
  meeting_type: null,
  meeting_source: null,
  meeting_campaign: null,
  source_app: null,
  'hubs_signup-url': null,
  'hubs_signup-cta': null,
  hubs_content: null,
  'hubs_content-cta': null,
  hubs_offer: null,
  hubs_post: null,
  'hubs_post-cta': null
};

var TrackingParams = /*#__PURE__*/function (_Record) {
  _inherits(TrackingParams, _Record);

  function TrackingParams() {
    _classCallCheck(this, TrackingParams);

    return _possibleConstructorReturn(this, _getPrototypeOf(TrackingParams).apply(this, arguments));
  }

  _createClass(TrackingParams, [{
    key: "compact",
    value: function compact() {
      return this.reduce(function (truthyFields, fieldValue, fieldName) {
        if (fieldValue) {
          truthyFields[fieldName] = fieldValue;
        }

        return truthyFields;
      }, {});
    }
  }], [{
    key: "from",
    value: function from(json) {
      return new TrackingParams(json);
    }
  }]);

  return TrackingParams;
}(Record(defaults));

export { TrackingParams as default };